<script setup lang="ts">
  import { useGIPointsStore } from '@/stores/giPoints'
  import { useBoreholeSampleObservationStore } from '@/stores/boreholeSampleObservation'
  import { storeToRefs } from 'pinia'
  import GenericDialog from '@/components/dialog/GenericDialog.vue'

  const MAX_FILE_COUNT = 50

  const giPointStore = useGIPointsStore()
  const boreholeSampleObservationStore = useBoreholeSampleObservationStore()
  const { showUploadDialog } = storeToRefs(boreholeSampleObservationStore)

  const files = ref([])
  const uploading = ref(false)

  function fileRule(files: File[]) {
    return (
      files.length <= MAX_FILE_COUNT || `You can only upload a maximum of ${MAX_FILE_COUNT} files.`
    )
  }

  function resetForm() {
    files.value = []
    uploading.value = false
  }

  async function uploadSTOWAFiles() {
    const formData = new FormData()
    for (const file of files.value) {
      formData.append('files', file)
    }
    const giPointId = giPointStore.items[0]?.id
    formData.append('gi_point', giPointId.toString())
    try {
      uploading.value = true
      await boreholeSampleObservationStore.uploadStowaFiles(formData)
    } catch (error) {
      console.log(error)
    } finally {
      resetForm()
    }
  }
</script>

<template>
  <GenericDialog
    :model-value="showUploadDialog"
    :max-width="600"
    @click:outside="boreholeSampleObservationStore.toggleUploadDialog"
  >
    <template #title> Upload STOWA database </template>
    <template #default>
      <v-file-input
        v-model="files"
        class="mt-3"
        color="primary"
        show-size
        prepend-icon="mdi-file"
        filled
        :counter="true"
        accept=".xlsx,.xlsm"
        multiple
        :rules="[fileRule]"
        :hint="`Only .xlsx and .xlsm files are allowed. Maximum ${MAX_FILE_COUNT} files.`"
        :persistent-hint="true"
      ></v-file-input>
    </template>
    <template #actions>
      <v-btn
        color="primary"
        variant="text"
        @click="boreholeSampleObservationStore.toggleUploadDialog"
      >
        Cancel
      </v-btn>
      <v-btn color="primary" variant="text" @click="uploadSTOWAFiles" :loading="uploading">
        Upload
      </v-btn>
    </template>
  </GenericDialog>
</template>

<style scoped></style>
